import { startGame } from './engine/startGame';
startGame();
